/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LocationBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.899 3.567c.415-.917-.526-1.86-1.444-1.447l-17.81 8.014c-1.073.483-.728 2.09.45 2.09h8.212c.27 0 .487.218.486.487l-.03 8.17c-.004 1.179 1.602 1.529 2.088.456L21.9 3.567ZM12.339 7.5l7.266-3.062a.097.097 0 0 1 .126.13L13.662 17.96c-.043.096-.188.063-.185-.042l.12-5.83a1.457 1.457 0 0 0-1.486-1.486H5.384c-.107.002-.138-.146-.04-.187L12.339 7.5Z" /></svg>);
const Location = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LocationBase} {...rest} ref={ref} />);
export default Location;